

// import webb from '../../../../interface_config';
// import UIEvents from '../../../../service/UI/UIEvents';
import { MiddlewareRegistry } from '../redux';

import { SET_ATTENDANCE_API } from './actionTypes';
import { sendUserAttendance } from './actions';
import './subscriber';

// import {
//     setGenericIFrameVisibilityState,
//     setGenericIFrameUrl
// } from '../../genericiframe/actions';
// import { CONFERENCE_JOINED, getCurrentConference } from '../conference';
// import { setActiveModalId } from '../modal';
// import { isLocalParticipantModerator } from '../participants';


// // import { SHARE_GENERICIFRAME_VIEW_ID } from './constants';


// declare var APP: Object;

// const GENERICIFRAME_COMMAND = 'genericiframe';

/**
 * Middleware that captures actions related to collaborative document editing
 * and notifies components not hooked into redux.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */

MiddlewareRegistry.register(({ getState }) => next => action => {
    switch (action.type) {

    case SET_ATTENDANCE_API:
    {

        const isLogout = action.isLogout;

        return sendUserAttendance({
            getState,
            isLogout
        });

    }

    default:
        return next(action);
    }
});

